<template>
  <v-row class="justify-center">
    <v-col>
      <Table
        :items="items"
        :headers="allHeaders"
        :openDialog="openDialog"
        :showEdit="false"
        @headersUpdated="updateHeadersEmpleados"
        class="mx-2"
        @refreshItems="refreshItems"
        :showRefresh="true"
        :showPagination="true"
        :itemsPerPage="20"
      />
      <v-dialog
        v-model="open"
        max-width="500px"
        persistent
        @keydown.esc="reset(false)"
      >
        <v-card class="mx-auto px-2" max-width="700px">
          <v-col>
            <v-card-title class="mt-n2 d-flex justify-center">
              {{ mode }}
            </v-card-title>
            <v-form @submit.prevent="submitForm" ref="form" v-model="valid">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mx-1"
              >
                {{ alertValidate }}
              </v-alert>
              <v-alert
                v-if="showLimitAlert"
                type="warning"
                dense
                outlined
                @input="showLimitAlert = false"
              >
                {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
              </v-alert>
              <v-autocomplete
                :label="$tc('schedules.employees')"
                name="empleados"
                v-model="employee"
                outlined
                :items="employeesWithSelectAll"
                multiple
                item-value="empId"
                item-text="fullName"
                :filter="customFilter"
                :search-input.sync="searchEmployee"
              >
                <template v-slot:item="{ item }">
                  <v-list-item @click.stop="toggleItem(item)">
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="isSelected(item)"
                        :indeterminate="isIndeterminate(item)"
                        dense
                        hide-details
                        readonly
                      />
                    </v-list-item-action>
                    <v-list-item-content class="ml-n3">
                      <v-list-item-title>{{
                        item.empId === "all"
                          ? item.fullName
                          : item.fullName + " (" + item.file + ")"
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 2">
                    <span>{{
                      item.empId === "all"
                        ? item.fullName
                        : item.fullName + " (" + item.file + ")"
                    }}</span>
                  </v-chip>
                  <span v-if="index === 2" class="grey--text text-caption">
                    (+ {{ employee.length - 2 }} )
                  </span>
                </template>
              </v-autocomplete>
              <div class="d-flex justify-space-between">
                <v-btn class="bt-exit" @click="reset(false)">{{
                  $tc("editRegistrations.cancel")
                }}</v-btn>
                <v-btn type="submit" class="bt-acept">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </v-form>
          </v-col>
        </v-card>
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="maxWidth[1]"
      />
    </v-col>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>

<script>
import Table from "@/components/Complement/TableWithSearch";
import FormOrder from "@/components/Complement/FormOrder.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import operators from "@/store/operadores/operators";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    Table,
    FormOrder,
    DeleteDialog,
    Snackbar,
    Loader,
  },
  data() {
    return {
      title: this.$tc("operators.employees"),
      titleTable: "Operadores_y_Relaciones",
      titleDelete: this.$tc("operators.deleteEmployeeToRelation"),
      isLoading: true,
      nameOper: "",
      maxWidth: ["550px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      oldItems: null,
      valid: true,
      alertValidate: "",
      employee: [],
      searchEmployee: "",
      maxEmployees: 300,
      showLimitAlert: false,
      error: false,
      order: "apellido",
    };
  },
  computed: {
    allHeaders() {
      return configTable.state.colums.empleados;
    },
    infoOperator() {
      const { edit } = operators.state;
      return { nombre: edit.nombre, login: edit.login };
    },
    items() {
      return operators.state.edit.empleados;
    },
    employees() {
      return this.$store.state.employees.employees;
    },

    employeesSelected() {
      const editEmpleados = operators.state.edit.empleados;

      if (!editEmpleados || editEmpleados.length === 0) {
        return this.employees;
      }

      return this.employees.filter(
        (model) =>
          !editEmpleados.some((selected) => selected.empId === model.empId),
      );
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", fullName: "Seleccionar todos", file: "" },
        ...this.employeesSelected,
      ];
    },

    mode: {
      get() {
        return operators.state.modeFormRelation;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.openFormRelation;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return operators.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  async mounted() {
    this.$store
      .dispatch("employees/getEmployees", {
        photo: false,
        order: this.order,
        soloActivos: true,
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  methods: {
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },

    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      this.saveForm(itemsComplete);
    },

    isSelected(item) {
      if (item.empId === "all") {
        return this.employee.length === this.employees.length;
      }

      return this.employee.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.employee.length > 0 && this.employee.length < this.employees.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.employee.length > 0;

        if (isAllSelected) {
          this.employee = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.employees.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.employee = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.employee = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.employee.includes(item.empId);

      if (exists) {
        this.employee = this.employee.filter((id) => id !== item.empId);
        this.showLimitAlert = false;
      } else {
        if (this.employee.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.employee = [...this.employee, item.empId];

        if (this.employee.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.fullName?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },

    async refreshItems() {
      await operators.dispatch("getOperatorId", operators.state.idOper);
    },
    updateHeadersEmpleados(headers) {
      const updatedColums = { ...configTable.state.colums, empleados: headers };
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    addEmployee(form) {
      const empIds =
        typeof form.empleados === "string"
          ? form.empleados.split(",")
          : [form.empleados];
      let empleados = [];

      for (const id of empIds) {
        let empleado = this.employees.find((employee) => employee.empId == id);

        if (!empleado) {
          this.showAlert(`Empleado con empId ${id} no encontrado.`, "#FF8D58");
          return; // 🔥 ahora sí corta toda la función
        }

        empleados.push({
          empId: Number(id),
          nombre: `${empleado.lastName} ${empleado.name}`,
          operId: operators.state.edit.operId,
        });
      }

      operators.commit("setNew", empleados);
      operators
        .dispatch("addEmployeeToOperator")
        .then(() => {
          this.showAlert(this.$tc("operators.addEmployeeSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
      this.reset(false);
    },

    async openDialog(type, item) {
      this.typeForm = type;

      switch (this.typeForm) {
        case "add":
          operators.commit(
            "setModeFormRelation",
            this.$tc("operators.addEmployeeToRelation"),
          );
          operators.commit("setOpenFormRelation", true);
          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          this.itemToDelete = {
            ...item,
            operId: operators.state.edit.operId,
          };
          break;

        default:
          break;
      }
    },

    reset(value) {
      operators.commit("setOpenFormRelation", value);
      this.employee = [];
    },

    saveForm(items) {
      if (this.typeForm === "add") {
        this.addEmployee(items);
      }
    },
    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      operators
        .dispatch("deleteEmployeeToOperator")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("operators.deleteEmployeeSuccess"),
            "#82A1D0",
          );
        })
        .catch((e) => {
          this.showAlert(e.response.data.error.message, "#FF8D58");
        });
    },

    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
  },
};
</script>
<style>
.paginado {
  padding-top: 10px;
  padding-bottom: 10px;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
